import { useCart } from "@shopify/hydrogen";

export function useCheckoutActions() {
  const { checkoutUrl, totalQuantity, cost } = useCart();

  const subtotalAmount = cost?.subtotalAmount;
  return {
    models: {
      checkoutUrl,
      totalQuantity,
      cost,
      subtotalAmount,
      emptyCart: totalQuantity != 0,
    },
  };
}
